import { fetcher } from '@commenda/utils';

export type BulkSendCompanyMessageParams = {
  companyIds: number[];
  message: string;
};

export type BulkSendCompanyMessageResultItem = {
  companyId: number;
  success: boolean;
  error?: string;
};

export type BulkSendCompanyMessageResponse = {
  job: { id: string };
};

type BulkSendCompanyMessageResult = {
  success: boolean;
  data?: BulkSendCompanyMessageResponse;
  error?: string;
  statusCode?: number;
};

export async function bulkSendCompanyMessage({
  companyIds,
  message,
}: BulkSendCompanyMessageParams): Promise<BulkSendCompanyMessageResult> {
  try {
    const response = await fetcher('chatRoom/message/bulk-companies', {
      method: 'POST',
      body: { companyIds, message },
    });

    if (!response.ok) {
      const responseData = await response.json();
      return {
        success: false,
        error: responseData?.message || 'Failed to send bulk message',
        statusCode: response.status,
      };
    }

    const responseData: BulkSendCompanyMessageResponse = await response.json();
    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to send bulk message';
    return {
      success: false,
      error: errorMessage,
      statusCode: 500,
    };
  }
}
